module.exports = __webpack_public_path__ + "static/img/cont3601.1e90a1f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont3601.jpg
// module id = XB1f
// module chunks = 0